import React from "react";

// Blank placeholder shown while a lazy route chunk downloads.
export const LazyFallback = () => (
  <div style={{ width: "100%", height: "100%" }} />
);
